import {PageManager} from "./PageManager";
import * as React from "react";
import {CSSProperties} from "react";
import {AnnotationDiv} from "./AnnotationDiv";
import {SingleEvent} from "shared/core/Events/SingleEvent";
import {PDFButton, PDFField} from "PDFLib/api";
import {PDFName, PDFRef, PDFString} from "PDFLib/core";

export class AnnotationManager{
    public Id:string;
    public OnRefresh:SingleEvent;
    public Field:PDFField;
    public FontRegEx=/\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/
    constructor(public Page:PageManager, public AnotationObject:any) {
        this.Id=this.AnotationObject.id.replace('R','');

        if(this.AnotationObject.fieldName!=null)
        {
            this.Field=this.Page.Document.getForm().getFields().find(x=>x.ref.objectNumber==this.Id as any);
        }

        if(this.Field==null)
        {
            this.Page.Document.getForm().getFields().forEach(x=>{
                if(x.acroField==null||x.acroField.Kids()==null)
                    return;

                let kids=x.acroField.Kids();

                for(let i=0;i<kids.size();i++)
                {
                    let currentKid=kids.get(i);
                    if(currentKid instanceof PDFRef&&currentKid.objectNumber==this.Id as any)
                        this.Field= x;

                }
            });

        }

        this.OnRefresh=new SingleEvent<any>();
    }

    public GetFieldName(){
        if(this.Field==null)
            return '';

        return this.Field.getName();
    }



    public GetDimension():{Top:number,Left:number,Width:number,Height:number}{
        let viewPort=this.Page.PageObject.getViewport({ scale: 1.4 });

        let rect= this.AnotationObject.rect;
        let convertedRect=viewPort.convertToViewportRectangle(rect);

        return {
            Left:Math.min(convertedRect[0],convertedRect[2]),
            Top:Math.min(convertedRect[1],convertedRect[3]),
            Width:Math.abs(convertedRect[0]-convertedRect[2]),
            Height:Math.abs(convertedRect[1]-convertedRect[3])
        }
    }

    public GetFieldSettings(){
        return this.Page.DocumentManager.GetFieldSettingsByPDFFieldId(this.Id);
    }


    public Refresh(){
        this.OnRefresh.Publish();
    }

    RenderRect() {

        return (
           <AnnotationDiv AnnotationManager={this}/>
        )
    }

    public Remove(){
        //this.Field.doc.getForm().acroForm.removeField(this.Field.acroField);
        this.Field?.Remove();

        this.Page.DocumentManager.RefreshDocument();
    }
    public Click() {
        this.Page.DocumentManager.SetSelectedPDFField(this);
    }

    public MoveTo(x,y,refreshAfterMove:boolean=true)
    {
        x=Math.max(0,x/1.4);
        y=Math.max(0,y/1.4);


        let cropBox=this.Page.PageLib.getCropBox();

        for(let widget of this.Field.acroField.getWidgets())
        {
            let rect=widget.getRectangle();
            rect.x=Math.min(cropBox.x+x,cropBox.width-rect.width+cropBox.x);
            rect.y=Math.max(cropBox.height+cropBox.y-rect.height-y,cropBox.y);
            widget.setRectangle(rect);


        }

        if(refreshAfterMove)
            this.Page.DocumentManager.RefreshDocument();


    }


    public SetBackgroundColor(color:any[])
    {
        if(color==null||color.length<3)
            return;
        for(let widget of this.Field.acroField.getWidgets())
        {
            let mk=widget.getOrCreateAppearanceCharacteristics();
            mk.setBackgroundColor(color);
        }
    }

    public GetFontSize()
    {
        let font=this.Field.acroField.DA();
        let matches=this.FontRegEx.exec(font.toString());
        if(matches==null||matches.length<3)
            return '';

        return matches[2];
    }

    public SetFontSize(fontSize:any)
    {
        let font=this.Field.acroField.DA().toString();
        let matches=this.FontRegEx.exec(font);
        if(matches==null||matches.length<3)
            return '';
        let newValue='/'+matches[1]+' '+fontSize+' Tf';
        font=font.replace(matches[0],newValue);
        this.Field.acroField.dict.set(PDFName.of('DA'),PDFString.of(font));
    }

    public GetBackgroundColor():number[]
    {

        for(let widget of this.Field.acroField.getWidgets())
        {
            let mk=widget.getAppearanceCharacteristics();
            if(mk==null)
                continue;

            if(mk.getBackgroundColor()!=null)
                return mk.getBackgroundColor();
        }

        return null;
    }

    public SetBorderColor(color:any[])
    {
        if(color==null||color.length<3)
            return;
        for(let widget of this.Field.acroField.getWidgets())
        {
            let mk=widget.getOrCreateAppearanceCharacteristics();
            mk.setBorderColor(color);
        }
    }


    public GetBorderColor():number[]
    {

        for(let widget of this.Field.acroField.getWidgets())
        {
            let mk=widget.getAppearanceCharacteristics();
            if(mk==null)
                continue;

            if(mk.getBorderColor()!=null)
                return mk.getBorderColor();
        }

        return null;
    }




    public ResizeTo(width,height,refreshAfterMove:boolean=true)
    {
        width=Math.max(5,width/1.4);
        height=Math.max(5,height/1.4);


        let cropBox=this.Page.PageLib.getCropBox();

        for(let widget of this.Field.acroField.getWidgets())
        {

            let rect=widget.getRectangle();
            rect.y=rect.y+rect.height-height;
            rect.height=height;
            rect.width=width;
            widget.setRectangle(rect)
            if(refreshAfterMove)
                this.Page.DocumentManager.RefreshDocument();
        }


        if(!(this.Field instanceof PDFButton)) {

          //  this.Field.defaultUpdateAppearances(this.Page.DocumentManager.Document.getForm().getDefaultFont());
        }



    }

    SetAlignment(value:any)
    {
        for(let widget of this.Field.acroField.getWidgets())
        {
            widget.setAlingment(value);
        }
    }

    GetAlignment() {
        for(let widget of this.Field.acroField.getWidgets())
        {
            let mk=widget.getAppearanceCharacteristics();
            if(mk==null)
                continue;

            return widget.getAlingment();
        }

        return null;
    }

}